import Encoder from '@/roc/url/Encoder';
import Decoder from '@/roc/url/Decoder';
import Compressor from '@/roc/url/Compressor';

const decompressQueryString = function (buffer) {
  return Compressor.decompress(buffer);
};

const compressQueryString = function (buffer) {
  return Compressor.compress(buffer);
};

const createLayoutUrl = function (params, mode = 'compressed') {
  switch (mode) {
    case 'plain':
      return process.env.VUE_APP_BASE_URL + '/?l=' + encodeURIComponent(params.join('-'));
    case 'compressed':
      return process.env.VUE_APP_BASE_URL + '/?b=' + compressQueryString(params.join('-'));
  }
};

const decodeLayoutFromUrl = function () {
  const url = new URL(window.location.href);

  if (url.searchParams.has('l')) {
    return Decoder.decodePlainURL(
      decodeURIComponent(url.searchParams.get('l')).split('-')
    );
  }

  if (url.searchParams.has('b')) {
    return Decoder.decodePlainURL(
      decompressQueryString(url.searchParams.get('b')).split('-')
    );
  }

  return null;
};

const LayoutUrl = {
  encodeURL: function (era, wonders, artifacts, expansions, buildings) {
    return createLayoutUrl(
      Encoder.encodeToURL(era, wonders, artifacts, expansions, buildings)
    );
  },
  decodeURL: decodeLayoutFromUrl,
};

export default LayoutUrl;
